<template>
  <div class="center-support">
    <div class="center-support__header">
      <div class="header-icon">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.12502 12.5003C3.75426 12.5004 3.38813 12.418 3.05314 12.2591C2.71815 12.1003 2.4227 11.8688 2.18818 11.5817C1.95366 11.2945 1.78595 10.9588 1.6972 10.5988C1.60845 10.2388 1.60087 9.86361 1.67502 9.50034C1.80376 8.92569 2.12669 8.41299 2.58938 8.04867C3.05206 7.68436 3.6262 7.4907 4.21502 7.50034H5.00002V12.5003H4.12502Z"
            fill="white"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.875 12.5003C12.2458 12.5004 12.6119 12.418 12.9469 12.2591C13.2819 12.1003 13.5773 11.8688 13.8118 11.5817C14.0464 11.2945 14.2141 10.9588 14.3028 10.5988C14.3916 10.2388 14.3992 9.86361 14.325 9.50034C14.1963 8.92569 13.8733 8.41299 13.4106 8.04867C12.948 7.68436 12.3738 7.4907 11.785 7.50034H11V12.5003H11.875Z"
            fill="white"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.49996 7.50014V6.91014C3.48195 5.87985 3.8138 4.87389 4.44133 4.05656C5.06886 3.23923 5.95498 2.65882 6.95496 2.41014C7.61768 2.25191 8.30768 2.24623 8.97291 2.39354C9.63814 2.54085 10.2612 2.83729 10.7952 3.26052C11.3292 3.68374 11.7601 4.22269 12.0554 4.83671C12.3507 5.45073 12.5027 6.1238 12.5 6.80514V7.50014"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5 12.5C5 12.8978 5.15804 13.2794 5.43934 13.5607C5.72064 13.842 6.10218 14 6.5 14"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path d="M12 7.5H11V12.5H12V7.5Z" fill="white" />
        </svg>
      </div>
      <div class="header-label">
        <span>Центр підтримки та сповіщень</span>
      </div>
    </div>
    <div class="center-support__body">
      <div class="body-view-switcher">
        <div
          class="body-view-switcher__item"
          :class="{ active: currentView === 'notification' }"
          @click="switchView('notification')"
        >
          <span>Сповіщення</span>
        </div>
        <div
          class="body-view-switcher__item"
          :class="{ active: currentView === 'technical' }"
          @click="switchView('technical')"
        >
          <span>Технічна підтримка</span>
        </div>
      </div>
      <component
        :is="currentViewComponent"
        :groupedData="groupedServices"
        :dataLoading="isDataLoading"
        :services="services"
      ></component>
    </div>
  </div>
</template>

<script>
import NotificationSupport from '@vue-app/views/centerSupport/supports/NotificationSupport.vue'
import TechnicalSupport from '@vue-app/views/centerSupport/supports/TechnicalSupport.vue'
import SystemAvailabilityService from '@js-app/services/support/system-availability-service'
import moment from 'moment/moment'
export default {
  name: 'CenterSupport',

  components: {
    NotificationSupport,
    TechnicalSupport,
  },

  data() {
    return {
      currentView: 'notification',
      groupedServices: [],
      isDataLoading: false,
      services: {
        '3DS UPC': 'xpaytoupc/api/3ds2_2/cavv/',
        '3DS PUMB': 'v1/cavv',
        'АБС Б2': 'api/v2/contragent/id',
        'VISA C2A': 'pullFundsTransactionsPost',
        'VISA A2C': 'pushFundsTransactionsPost',
        'MASTERCARD C2A': 'c2a',
        'MASTERCARD A2C': 'a2c',
      },
    }
  },

  created() {
    this.getSystemAvailabilitySupport()
  },

  computed: {
    currentViewComponent() {
      if (this.currentView === 'notification') {
        return 'NotificationSupport'
      }

      if (this.currentView === 'technical') {
        return 'TechnicalSupport'
      }
    },
  },

  methods: {
    async getSystemAvailabilitySupport() {
      this.isDataLoading = true
      try {
        let gate_apis_value = Object.values(this.services).map(
          (value) => `-\"${value}\"`
        )
        const from = moment(Date.now())
          .startOf('hour')
          .add(1, 'hour')
          .subtract(4, 'hours')
          .format('YYYY-MM-DD HH:mm:ss')
        const to = moment(Date.now())
          .startOf('hour')
          .add(1, 'hour')
          .format('YYYY-MM-DD HH:mm:ss')

        const data = {
          gate_apis: gate_apis_value,
          from: from,
          to: to,
        }

        const response =
          await SystemAvailabilityService.getSystemAvailabilityService(data)

        Object.keys(this.services).forEach((serviceName, index) => {
          let responseKey = `-\"${this.services[serviceName]}\"`
          if (response.data.hasOwnProperty(responseKey)) {
            this.groupedServices.push({
              id: index + 1,
              service: response.data[responseKey].service,
              time_points: response.data[responseKey].time_points,
            })
          } else {
            this.groupedServices.push({
              id: index + 1,
              service: serviceName,
              time_points: [],
            })
          }
        })

        this.isDataLoading = false
        return this.groupedServices
      } catch (e) {
        console.error(e)
      }
    },

    switchView(view) {
      this.currentView = view
      location.hash = view
    },
  },
}
</script>

<style lang="scss" scoped>
.center-support {
  padding-top: 30px;
  &__header {
    display: flex;
    align-items: center;
    gap: 20px;

    .header-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 27px;
      height: 27px;
      background-color: #64748B;
      border-radius: 8px;
    }

    .header-label {
      span {
        font-size: 20px;
        line-height: 25px;
        font-weight: 600;
        color: #585f6d;
      }
    }
  }

  &__body {
    .body-view-switcher {
      margin-top: 35px;
      margin-bottom: 30px;
      padding-bottom: 12px;
      border-bottom: 1px solid #eff2f8;
      display: flex;
      align-items: center;
      gap: 20px;

      .body-view-switcher__item {
        position: relative;
        cursor: pointer;
        color: #67768a;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;

        &.active {
          font-weight: 600;
          font-size: 16px;
          line-height: 28px;
          color: #465a8b;
          opacity: 1;

          &:after {
            content: '';
            display: block;
            position: absolute;
            left: 0;
            bottom: -15px;
            background: #64748B;
            border-radius: 8px;
            width: 100%;
            height: 5px;
          }
        }
      }
    }
  }
}
</style>
